import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const Home = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="intro-box">
              <h1 className="greeting">Hi, I'm Michael</h1>
              <h2 className="title">Driven IT Professional</h2>
              <p className="description">
                B.S. in Information Technology graduate. 
                Experienced in Linux system administration and DevOps. 
                Passionate about technology, team collaboration, and continuous growth.
              </p>
              <div className="cta-buttons">
                <Link to="/about" className="primary-btn floating-btn">
                  Learn About Me
                </Link>
                <Link to="/contact" className="primary-btn floating-btn">
                  Get in Touch
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="profile-image-container">
              <div className="profile-image-wrapper">
                <img 
                  src="/ACF2FA05-6703-4132-A117-BFF68F8F7F4E.JPG"
                  alt="Michael Shamsutdinov" 
                  className="profile-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home; 